import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedCpfInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function MaskedCpfInput({ value, onChange, name }: MaskedCpfInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    {
      mask: [
        { mask: '000.000.000-00' },  // CPF
        { mask: '00.000.000/0000-00' }  // CNPJ
      ]
    },
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value, setValue]);

  return <Input ref={ref} name={name} placeholder="CPF ou CNPJ" />;
}
